import React, {PureComponent} from "react";
import {DialogManagerProps, IDialogAction, INotificationDialogOptions} from "../../../../../store/dialog-manager/types";
import styles from "./notification-dialog.module.css";
import dialogStyles from "../dialog.module.css";
import bonuses from "../../../../styles/bonuses.module.css";
import icons from "../../../../styles/icons.module.css";
import animations from "../../../../styles/animations.module.css";
import {cssHelper} from "../../../../utils/cssHelper";
import renderText from "../../../renderText";
import {loadScene} from "../../../../../store/routing/actions";
import {Overlay} from "../../../overlay/Overlay";
import i18n from "../../../../i18n";

export class NotificationDialog extends PureComponent<INotificationDialogOptions & DialogManagerProps> {
    render() {
        return (
            <Overlay onClick={!this.hasActions() ? () => this.props.close() : undefined}>
                <button className={cssHelper(dialogStyles.close_button, icons.close).toString()} onClick={() => this.props.close()}>✖</button>

                <div className={dialogStyles.container}>
                    <figure className={`${dialogStyles.logo} logo`}/>

                    {renderText(this.props.title, 36, 56, 18, 40, styles.text)}
                    {renderText(this.props.text, 32, 40, 25, 50, styles.text)}

                    {this.renderRewards()}
                    {this.renderActions()}
                </div>
            </Overlay>
        );
    }

    private renderRewards() {
        if (!this.hasRewards())
            return;

        const bonusTitle = this.props.bonusTitle == null
            ? i18n("levelgained.reward")
            : this.props.bonusTitle;

        return (
            <div className={styles.reward_container}>
                {renderText(bonusTitle, 20, 45, 15, 50, styles.text)}

                {this.renderProgressRewards()}
                {this.renderBonusRewards()}
            </div>
        );
    }

    private renderProgressRewards() {
        if (!this.hasCoins() && !this.hasScore())
            return;

        const coins = this.hasCoins()
            ? (
                <div className={styles.coins}>
                    {this.props.coins} <i className={cssHelper(styles.icon, icons.coins).toString()}/>
                </div>
            )
            : undefined;

        const score = this.hasScore()
            ? <div className={styles.score}>{this.props.score} <i className={cssHelper(styles.icon, icons.score).toString()}/></div>
            : undefined;

        return (
            <div className={styles.progress_rewards_container}>
                {coins}
                {score}
            </div>
        );
    }

    private renderBonusRewards() {
        if (!this.hasBonuses())
            return;

        return this.props.bonuses!.map((bonus, i) => {
            return (
                <div key={i} className={styles.bonus_container}>
                    <i className={cssHelper(styles.bonus_icon, bonuses[bonus.icon]).toString()} />
                    <div>
                        {renderText(bonus.caption, 24, 40, 15, 50, styles.bonus_caption)}
                        {renderText(bonus.description, 18, 26, 15, 50, styles.bonus_description)}
                    </div>
                </div>
            );
        });
    }

    private renderActions() {
        if (!this.hasActions()) {
            return renderText(i18n("dialog.taptocontinue"), 26, 32, 15, 30, cssHelper(styles.tap_to_continue, animations.blink).toString());
        }

        return (
            <div className={styles.action_container}>
                {this.props.actions!.map((action, i) => (
                    <button key={i} className={styles.action} onClick={() => this.actionClick(action)}>{action.label}</button>
                ))}
            </div>
        );
    }

    private hasCoins() {
        return this.props.coins && this.props.coins > 0;
    }

    private hasScore() {
        return this.props.score && this.props.score > 0;
    }

    private hasBonuses() {
        return this.props.bonuses && this.props.bonuses.length > 0;
    }

    private hasActions() {
        return this.props.actions && this.props.actions.length > 0;
    }

    private hasRewards() {
        return this.hasCoins()
            || this.hasScore()
            || this.hasBonuses();
    }

    actionClick(action: IDialogAction) {
        this.props.close(action.payload);

        if (action.action) {
            this.props.dispatch(loadScene.request(action.action));
        }
    }
}